import { Component, Input, OnInit } from "@angular/core";
import { ToasterService } from "./services/toaster.service";
import { Toast } from "./toast.interface";
import { ToasterComponent } from "./toaster.component";



@Component({
  selector: "app-toaster-container",
  template: `
    @for (toast of toasts; track toast; let i = $index) {
      <app-toaster
        [toast]="toast"
        [i]="i"
        (remove)="remove(i)"
      ></app-toaster>
    }
    `,
  styles: [],
  imports: [ToasterComponent]
})
export class ToasterContainerComponent implements OnInit {
  toasts: Toast[] = [];

  constructor(private toaster: ToasterService) {}

  ngOnInit() {
    this.toaster.toast$.subscribe((toast) => {
      this.toasts = [toast, ...this.toasts];
      setTimeout(() => this.toasts.pop(), toast.delay || 10000);
    });
  }

  remove(index: number) {
    this.toasts = this.toasts.filter((v, i) => i !== index);
    //this.toasts.splice(index, 1);
  }
}
